import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Keyboard } from 'swiper';

import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import { BtnGreyIconText24, ChipsButton, ChipsButtonAll } from '../Elements';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

import './SwipperNav.scss';

import classes from './NavRelease.module.scss';

SwiperCore.use([Navigation, Keyboard]);

const NavRelease = ({
  dataNav,
  onClickAdd,
  modeSetting,
  onClickChips,
  modeUser,
  modeWidth = false,
  handleDelRelease,
  handleRename
}) => {
  const language = useUserState().user.language;

  const length = dataNav.length;

  return (
    <div
      className={cn(
        classes.navRelease,
        modeWidth && classes.navRelease_flexstart
      )}
    >
      {modeWidth ? (
        <Media
          queries={{
            small: '(max-width: 1279px)'
          }}
        >
          {matches => (
            <Swiper
              allowTouchMove={matches.small}
              slidesPerView="auto"
              navigation={false}
              keyboard={{
                enabled: true,
                pageUpDown: false
              }}
              className={
                modeUser
                  ? classes.chipsContainer_modeUser
                  : classes.chipsContainer
              }
            >
              {dataNav.map((dataNavItem, index) => (
                <SwiperSlide key={dataNavItem.id}>
                  <ChipsButton
                    {...dataNavItem}
                    index={index}
                    modeSetting={modeSetting}
                    manyTabs={length > 1}
                    onClickChips={onClickChips}
                    id={dataNavItem.id}
                    modeWidth={modeWidth}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </Media>
      ) : (
        <>
          <Media
            queries={{
              large: '(min-width: 1280px)'
            }}
          >
            {matches =>
              matches.large && (
                <>
                  <div
                    className={cn(
                      classes.boxOverflow,
                      classes.boxOverflow_left
                    )}
                  ></div>
                  <div
                    className={cn(
                      classes.boxOverflow,
                      classes.boxOverflow_right
                    )}
                  ></div>
                </>
              )
            }
          </Media>
          <Swiper
            allowTouchMove={false}
            slidesPerView="auto"
            navigation={{ disabledClass: 'swiperNavDisabled' }}
            keyboard={{
              enabled: true,
              pageUpDown: false
            }}
            className={
              modeUser
                ? classes.chipsContainer_modeUser
                : classes.chipsContainer
            }
          >
            {length > 1 && (
              <SwiperSlide>
                <ChipsButtonAll length={length} onClickChips={onClickChips} />
              </SwiperSlide>
            )}

            {dataNav.map((dataNavItem, index) => (
              <SwiperSlide key={dataNavItem.id}>
                <ChipsButton
                  {...dataNavItem}
                  index={index}
                  modeSetting={modeSetting}
                  manyTabs={length > 1}
                  onClickChips={onClickChips}
                  id={dataNavItem.id}
                  modeWidth={modeWidth}
                  handleDelRelease={handleDelRelease}
                  handleRename={handleRename}
                  modeUser={modeUser}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </>
      )}
      {!modeUser && (
        <Media
          queries={{
            large: '(min-width: 1280px)'
          }}
        >
          {matches => (
            <div className={classes.underlineButton}>
              <BtnGreyIconText24
                onClick={onClickAdd}
                textButton={
                  matches.large && t('navRelease', 'ADD_OPTION', language)
                }
                icon={'Icn_Add-3'}
              />
            </div>
          )}
        </Media>
      )}
    </div>
  );
};

NavRelease.propTypes = {
  dataNav: PropTypes.array.isRequired,
  onClickAdd: PropTypes.func,
  modeSetting: PropTypes.string,
  onClickChips: PropTypes.func.isRequired,
  modeUser: PropTypes.bool,
  modeWidth: PropTypes.bool,
  handleDelRelease: PropTypes.func,
  handleRename: PropTypes.func
};

export default NavRelease;
